export const getContactName = (contact: {
    contact_person_full_name?: string;
    contact_person_first_name?: string;
    contact_person_last_name?: string;
  }): string => {
    const fullName = contact.contact_person_full_name?.trim();
    if (fullName && fullName.length > 0) {
      return fullName;
    }
  
    const firstName = contact.contact_person_first_name?.trim();
    const lastName = contact.contact_person_last_name?.trim();
  
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }
  
    return firstName || lastName || "Unknown";
  };